import React, { useMemo, useContext } from 'react';
import RegisterContext from '../../RegisterContext';
import { Form, Button } from "react-bootstrap";
import useForm from 'hooks/useForm';
import { fieldsForm, schema } from './fields'

export default function IdCellStep({ labels, push }) {
  console.log(labels)
  const { user, setUser, goToStepsProcess } = useContext(RegisterContext)

  if (user) {
    push('already_registered')
  }
  const {
    formik,
    renderElementsForm,
    renderElement
  } = useForm({
    fieldsForm,
    schema,
    onSubmit: handleSubmit
  })

  const formElements = useMemo(() => renderElementsForm(), [fieldsForm]);

  //const [register, { data, error }] = useMutation(REGISTER);

  function handleSubmit(values) {
    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };
    fetch(`${window.location.origin}/register/registration`, requestMetadata)
      .then(res => res.json())
      .then(result => {
        if (result?.register?.firstName) {
          setUser(result.register)
          push('already_registered')
        } else {
          goToStepsProcess()
        }
      }, error => {
        console.log(error)
      })
  }

  return (
    <div>
      <Form onSubmit={formik.handleSubmit}>
        {formElements.map((el, index) =>
          renderElement(el, labels)
        )}

        <Form.Text className="link-text" onClick={() => push('not_israeli')}>I do not have Israeli citizenship</Form.Text>
        <p dangerouslySetInnerHTML={{ __html: labels.details }} />
        <Button className="btn_submit" aria-label={labels.continue} variant="primary" type="submit" >
          {labels.continue}
        </Button>
      </Form>
    </div>
  )
}